import type { ComponentType } from 'react';
import { LayoutColumn as OriginalLayoutColumn } from '@kiwicom/orbit-components';
import type { Props } from '@kiwicom/orbit-components/lib/Layout/LayoutColumn/types';

type LayoutProps = Omit<Props, 'element'>;

export default (function LayoutColumn(props: LayoutProps) {
  return <OriginalLayoutColumn {...props} as="div" />;
} as ComponentType<Props>);
